export default __webpack_public_path__ + "static/media/phone.6b98bd00.gif";